module.exports = __webpack_public_path__ + "assets/img/banner-12.e7c7c291.jpg";